import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Notification } from '../../interfaces/notification.model';
import { AlertController, ModalController } from 'ionic-angular';
import { NotificationComponent } from '../../components/notification/notification';

/*
  Generated class for the NotificationProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class NotificationProvider {

  notifications: Notification[];
  notifsNotRead: any[];
  skipAllStatus: boolean;

  constructor(
    public http: HttpClient,
    public storage: Storage,
    public alertCtrl: AlertController,
    public modalCtrl: ModalController
  ) {}

  getNotifications() {
    return new Promise((resolve, reject) => {
      this.storage.get("notifications").then((data:Notification[]) => {
        this.notifications = data;
        if(this.notifications){
          this.notifications = data.sort((a, b) => {
            return +new Date(b.NotificationDate) - +new Date(a.NotificationDate)
          });
        }
        resolve(this.notifications);
      });
    });
  }

  updateNotifsInStorage(WSNotifs: any){
    return new Promise((resolve, reject) => {

      if(WSNotifs == null){
        resolve();
      }

      let addedNotifications = WSNotifs.Added;
      let deletedNotifications = WSNotifs.Deleted; 

      if(addedNotifications.length > 0 || deletedNotifications.length > 0){
          this.getNotifications().then(notificationList => {
            if(this.notifications !== null && this.notifications.length > 0){
              
              let promise1 = this.addNotifications(addedNotifications);
              let promise2 = this.deleteNotifications(deletedNotifications);

              Promise.all([promise1, promise2]).then(values => {
                this.storage.set("notifications", this.notifications);
                resolve(this.notifications);
              });
            } else {
              this.storage.set("notifications", addedNotifications);
              resolve(addedNotifications);
            }
          });
      } else {
        resolve();
      }
    });
  }

  addNotifications(addedNotifications){
    return new Promise((resolve, reject) => {
      if(addedNotifications.length > 0){
        for(let notif of addedNotifications) {
          notif.isRead = false;
          let index = this.notifications.findIndex(item => item.NotificationId == notif.NotificationId);
          if(index == -1){
            this.notifications.push(notif);
          } else {
            this.notifications[index] = notif;  
          }
        }
        resolve();
      } else {
        resolve();
      }
    });
  }

  deleteNotifications(deletedNotifications){
    return new Promise((resolve, reject) => {
      if(deletedNotifications.length > 0){
        for(let deletedNotifId of deletedNotifications) {
          let index = this.notifications.findIndex(item => item.NotificationId == deletedNotifId);
          if(index !== -1){
            this.notifications.splice(index, 1);
          }
        }
        resolve();
      } else {
        resolve();
      }
    });
  }

  async showAllNotifications(){
    if(this.notifications.length > 0){

      for (var index = 0; index < this.notifications.length; index++) {
        let currentNotif = this.notifications[index];

        if(typeof currentNotif.isRead == 'undefined'){
          currentNotif.isRead = false;
        }

        if(!currentNotif.isRead){
          let result = await this.showNotificationPopup(currentNotif);
          if(typeof result == 'string' && result === "skipAll"){
            this.skipAllStatus = true;
            break;
          } else {
            this.skipAllStatus = false;
            if(result){
              this.notifications[index].isRead = true;
            } else {
              this.notifications[index].isRead = false;
            }
          }
        }
      }
      this.storage.set("notifications", this.notifications);
    } else {
      return;
    }
  }

  showNotificationPopup(currentNotif){
    return new Promise((resolve, reject) => {
      const moreThanOne = this.notifications.filter(notif => notif.isRead == false).length > 1 ? true : false;
      let notifModal = this.modalCtrl.create(NotificationComponent, { title: 'GENERAL.NOTIFICATIONS', notification: currentNotif, moreThanOne: moreThanOne });
      notifModal.onDidDismiss((data: {skipAll: boolean, read: boolean}) => {
        if(data.skipAll){
          resolve("skipAll");
        } else {
          resolve(data.read)
        }
      });
      notifModal.present();
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/notification/notification.ts